module.exports = __webpack_public_path__ + "static/media/agribusiness-discovery.18c436f9.svg";